(() => {
  angular.module('pims').directive('openText', ["$log", "ngDialog", "Messages", "toastr", "Notifications", ($log, ngDialog, Messages, toastr, Notifications) => {
    'ngInject';

    return {
      restrict: 'A',

      link(scope, element, attrs) {
        const user = scope.$eval(attrs.openText);
        element.on('click', () => {
          if (user.opt_out_sms_messages) {
            toastr.info(Notifications.patient.sms.optOutSmsMessages);
          } else {
            Messages.openText(user.id);
          }
        });
        scope.$on('$destroy', () => element.off());
      }

    };
  }]);
})();